import * as React from 'react';

interface BadgeProps {
  status?: number | boolean | string | any;
  paperStatus?: number | boolean | string | any;
}

interface StatusInfo {
  text: string;
  name: string;
  bg: string;
}

export default function Badge({ status, paperStatus }: BadgeProps) {
  //
  const checkStatus = (
    status: BadgeProps['status']
  ): StatusInfo | undefined => {
    if (status === 'blocked') {
      return {
        text: 'text-[#ffffff]',
        name: 'Blocked',
        bg: 'bg-[#b10303]',
      };
    } else if (status === 'active') {
      return {
        text: 'text-[#ffffff]',
        name: 'Active',
        bg: 'bg-[#076d0f]',
      };
    }
  };

  const getDeliveryOption = (status: number): StatusInfo | undefined => {
    if (status === 1) {
      return {
        text: 'text-[#ffffff]',
        name: 'Delivery',
        bg: 'bg-[#076d0f]',
      };
    } else if (status === 2) {
      return {
        text: 'text-[#ffffff]',
        name: 'Pickup',
        bg: 'bg-[#8406c3]',
      };
    }
  };

  const getPaperType = (paperStatus: number): StatusInfo | undefined => {
    if (paperStatus === 1) {
      return {
        text: 'text-[#ffffff]',
        name: 'Paper',
        bg: 'bg-[#0068ab]',
      };
    } else if (paperStatus === 2) {
      return {
        text: 'text-[#ffffff]',
        name: 'Journal',
        bg: 'bg-[#bb4a02]',
      };
    }
  };

  const deliveryInfo = getDeliveryOption(status);
  const paperTypeInfo = getPaperType(paperStatus);
  const statusInfo = checkStatus(status);

  return (
    <React.Fragment>
      <span
        className={`cursor-pointer text-[10px] inline-block w-[4rem] text-center rounded-[4px] px-2 py-0.5 ${statusInfo?.text} ${deliveryInfo?.text} ${paperTypeInfo?.text} ${statusInfo?.bg} ${deliveryInfo?.bg} ${paperTypeInfo?.bg} `}
      >
        {statusInfo?.name}
        {deliveryInfo?.name}
        {paperTypeInfo?.name}
      </span>
    </React.Fragment>
  );
}
